export const formatToRupiahIDN = (inputValue: string): string => {
    if (inputValue === ""){
        return ""
    }
    let number = parseInt(inputValue)
    const formattedNumber = number.toLocaleString('id-ID');
    return formattedNumber
}